import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ControlContainer, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReactiveComponent } from '@app/shared/components/reactive-component';
import { ngValueAccessor } from '@app/utils/ng-value-accessor';

@Component({
  selector: 'portal-toggleable-input',
  templateUrl: './toggleable-input.component.html',
  styles: [],
  providers: [ngValueAccessor(ToggleableInputComponent)],
  standalone: false,
})
export class ToggleableInputComponent extends ReactiveComponent implements OnInit {
  @Input()
  activeValue: any;

  @Input()
  formControlName: string;

  @Input()
  inactiveValue: any = null;

  @Input()
  input: TemplateRef<any>;

  @Input()
  label: TemplateRef<any>;

  @Output()
  stateChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public checked: boolean;
  public form: UntypedFormGroup;

  private value: any;

  get formControl(): UntypedFormControl {
    return this.form.get(`${this.formControlName}Toggled`) as UntypedFormControl;
  }

  constructor(private controlContainer: ControlContainer) {
    super();
  }

  ngOnInit() {
    this.form = this.controlContainer.control as UntypedFormGroup;

    this.form.addControl(`${this.formControlName}Toggled`, new UntypedFormControl());
  }

  writeValue(obj: any): void {
    this.checked = obj !== this.inactiveValue && obj != null;
    this.value = obj;

    this.formControl.setValue(this.checked, {
      emitEvent: false,
      onlySelf: true,
    });
  }

  update(checked: boolean) {
    this.checked = checked;

    if (this.checked === false) {
      this.onChange(this.inactiveValue);
    } else {
      this.onChange(this.activeValue);
    }

    this.formControl.setValue(this.checked);
    this.stateChange.emit(this.checked);
  }
}
